import React, {MutableRefObject, useRef} from 'react';

import PrimaryButton from '../Button/PrimaryButton';
import SecondaryButton from '../Button/SecondaryButton';

import useOutsideClick from '@rooks/use-outside-click';
import {HSpacer} from 'components/Layout/HSpacer';

interface ConfirmMessageProps extends React.HTMLAttributes<HTMLDivElement> {
  cancelText?: string;
  onCancel?: () => void;
  confirmText?: string;
  onConfirm?: () => void;
}

function ConfirmMessage({
  className,
  children,
  cancelText,
  onCancel,
  confirmText,
  onConfirm,
}: ConfirmMessageProps) {
  const ref = useRef() as MutableRefObject<HTMLDivElement>;
  useOutsideClick(ref, () => {
    onCancel && onCancel();
  });

  return (
    <div
      className={`absolute w-min z-50 bg-white rounded-huge border border-skyblue rounded-large p-4 shadow-skyblue-200 ${
        className || ''
      }`}
      ref={ref}
      onClick={e => e.stopPropagation()}
    >
      {children}
      <div className="mt-2 flex justify-between w-max">
        {onCancel && (
          <SecondaryButton className="p-3" onClick={onCancel}>
            {cancelText}
          </SecondaryButton>
        )}
        {onConfirm && onCancel && <HSpacer width="0.25rem" />}
        {onConfirm && (
          <PrimaryButton className="p-3" onClick={onConfirm}>
            {confirmText}
          </PrimaryButton>
        )}
      </div>
    </div>
  );
}

export default ConfirmMessage;
